/* ============================================================ */
/* MODERN PREMIUM PRODUCT PAGE - JS LOGIC                       */
/* ============================================================ */

document.addEventListener('DOMContentLoaded', function() {
  initGallery();
  initVariants();
  initQuantity();
  initAccordions();
});

/**
 * Gallery Logic
 */
function initGallery() {
  const thumbItems = document.querySelectorAll('.thumbnail-item');
  const mainImg = document.querySelector('.main-media-display img');
  
  if (!mainImg || thumbItems.length === 0) return;

  thumbItems.forEach(thumb => {
    thumb.addEventListener('click', function() {
      // Update active state
      thumbItems.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      
      // Update main image
      const newSrc = this.dataset.fullSrc;
      if (newSrc) {
        mainImg.src = newSrc;
      }
    });
  });
}

/**
 * Variant Selection Logic
 */
function initVariants() {
  const swatches = document.querySelectorAll('.color-swatch-item');
  const sizeBoxes = document.querySelectorAll('.size-box-item');
  const masterSelector = document.querySelector('.product-main-select'); // The hidden real select
  
  // Color Swatches
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function() {
      if (this.classList.contains('active')) return;
      
      const optionIndex = this.dataset.optionIndex;
      const value = this.dataset.value;
      
      swatches.forEach(s => {
        if (s.dataset.optionIndex === optionIndex) s.classList.remove('active');
      });
      this.classList.add('active');
      
      // Update label text
      const label = document.querySelector(`.option-label-active[data-index="${optionIndex}"] span`);
      if (label) label.textContent = value;
      
      updateMasterVariant();
    });
  });

  // Size Boxes
  sizeBoxes.forEach(box => {
    box.addEventListener('click', function() {
      if (this.classList.contains('active') || this.classList.contains('disabled')) return;
      
      const optionIndex = this.dataset.optionIndex;
      const value = this.dataset.value;
      
      sizeBoxes.forEach(s => {
        if (s.dataset.optionIndex === optionIndex) s.classList.remove('active');
      });
      this.classList.add('active');
      
      const label = document.querySelector(`.option-label-active[data-index="${optionIndex}"] span`);
      if (label) label.textContent = value;
      
      updateMasterVariant();
    });
  });

  function updateMasterVariant() {
    // Collect selected values
    const selectedValues = [];
    document.querySelectorAll('.product-option-group').forEach(group => {
      const active = group.querySelector('.active');
      if (active) selectedValues.push(active.dataset.value);
    });

    // Match with variant from JSON (injected into window or hidden element)
    if (window.productVariants) {
      const matched = window.productVariants.find(v => {
        return v.options.every((opt, i) => opt === selectedValues[i]);
      });

      if (matched) {
        // Update hidden input
        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput) variantInput.value = matched.id;
        
        // Update price
        const priceElement = document.querySelector('.product-main-price');
        if (priceElement) priceElement.textContent = formatMoney(matched.price);
        
        // Update Add to Cart button
        const atcBtn = document.querySelector('.add-to-cart-big');
        if (atcBtn) {
          if (matched.available) {
            atcBtn.disabled = false;
            atcBtn.querySelector('.atc-text').textContent = 'Add to Cart';
            atcBtn.querySelector('.atc-price').textContent = '- ' + formatMoney(matched.price);
          } else {
            atcBtn.disabled = true;
            atcBtn.querySelector('.atc-text').textContent = 'Sold Out';
            atcBtn.querySelector('.atc-price').textContent = '';
          }
        }

        // Update Gallery if variant has a featured image
        if (matched.featured_image) {
          const mainImg = document.querySelector('.main-media-display img');
          const thumbItems = document.querySelectorAll('.thumbnail-item');
          if (mainImg) {
            mainImg.src = matched.featured_image;
            // Also try to highlight corresponding thumbnail
            thumbItems.forEach(t => {
              if (t.dataset.fullSrc.includes(matched.featured_image)) {
                thumbItems.forEach(i => i.classList.remove('active'));
                t.classList.add('active');
              }
            });
          }
        }

        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url);
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
}

/**
 * Quantity Logic
 */
function initQuantity() {
  const container = document.querySelector('.quantity-control');
  if (!container) return;

  const input = container.querySelector('.qty-input-field');
  const minus = container.querySelector('.qty-minus');
  const plus = container.querySelector('.qty-plus');

  minus.addEventListener('click', (e) => {
    e.preventDefault();
    let val = parseInt(input.value) || 1;
    if (val > 1) input.value = val - 1;
  });

  plus.addEventListener('click', (e) => {
    e.preventDefault();
    let val = parseInt(input.value) || 1;
    input.value = val + 1;
  });
}

/**
 * Accordion Logic
 */
function initAccordions() {
  const headers = document.querySelectorAll('.modern-accordion-header');
  headers.forEach(header => {
    // Ensure initial state: remove active if already there (cleanup)
    const content = header.nextElementSibling;
    if (header.classList.contains('active') && !content.classList.contains('active')) {
       content.classList.add('active');
    }

    header.addEventListener('click', function(e) {
      e.preventDefault();
      const content = this.nextElementSibling;
      const isActive = this.classList.contains('active');
      
      // Close others (optional, FCTRY LAB doesn't necessarily do this but it's cleaner)
      // headers.forEach(h => {
      //   if (h !== this) {
      //     h.classList.remove('active');
      //     h.nextElementSibling.classList.remove('active');
      //   }
      // });

      // Toggle
      this.classList.toggle('active');
      content.classList.toggle('active');
    });
  });
}
